import script from "./TraitShopCardBundle.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopCardBundle.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopCardBundle.vue?vue&type=style&index=0&id=1afbe334&lang=scss"

const __exports__ = script;

export default __exports__